module.exports = __webpack_public_path__ + "img/logo-xju.d26b5193.png";